export function getCommerceFacetSetInitialState() {
    return {};
}
